import { Container } from "pixi.js";
import type { ViewportStore } from "./ViewportStore";

/**
 * The stage root every layer lives under — the design canvas with the fit-height policy.
 * Children are positioned in DESIGN UNITS around the viewport centre (origin at the centre, y down);
 * the root scales them so 1920 units always span the viewport height. Views read the viewport
 * store's `design` size and `shape` for their own rules.
 */
export class DesignSpaceRoot extends Container {
  private unsubscribe: (() => void) | null;

  public constructor(store: ViewportStore) {
    super({ label: "DesignSpaceRoot" });
    this.unsubscribe = store.subscribe((s) => {
      this.scale.set(s.scale, s.scale);
      this.position.set(s.css.width / 2, s.css.height / 2);
    });
  }

  /** CSS pixels per design unit. */
  public get designScale(): number {
    return this.scale.x;
  }

  public dispose(): void {
    this.unsubscribe?.();
    this.unsubscribe = null;
  }
}
